/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify,Dialog} from 'quasar'



export default { config: {"brand":{"primary":"#07314A","secondary":"#F6B900","accent":"#F57C01","dark":"#101010","positive":"#55fd35","negative":"#fe3636","warning":"#ff7c36"}},plugins: {Notify,Dialog} }

